import { request } from "@/utils/request";
import useSWR from "swr";

interface ResponseWallet {
  data: {
    cumulative_action: number;
    cumulative_user: number;
  };
}

async function fetchWallet(url: string) {
  const response = await request(url);
  const data = await response.json();
  return data as ResponseWallet;
}

export function useWallet() {
  const data = useSWR("/stats/wallet", fetchWallet, {
    refreshInterval: 15_000,
    errorRetryInterval: 10_000,
  });

  return data;
}
